import { Error, FieldValidationError } from '../models/index'
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ErrorCodes } from './error-codes';
import { Ui } from './ui';
import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
import * as moment from 'moment';

@Injectable()
export class ErrorHelper {
  constructor(private ui: Ui){}

  public toError(response: any) : Error {
    try {
      let error = new Error();
      return Object.assign(error, JSON.parse(response._body).error);
    } catch (e){
        // this.ui.toast('An unexpected error has occurred')
    }
  }

  public handleServerValidation(form: FormGroup, serverResponse: any){
    let errors = this.toError(serverResponse);

    if(errors && errors.errorCode == ErrorCodes.FIELD_VALIDATION_ERROR){
      this.resetServerValidation(form);
      for(let error of errors.fieldValidationErrors){
        var field = error.field;
        if(field){
          var match = field.match(/\.([a-zA-Z1-9]+)$/);
          if(match && match.length){
            field = match[1];
          }
        }
        let control = form.controls[field];
        if(control){
          control.setErrors({'server': error.validationMessage});
        } else {
          form.setErrors({'error': error.validationMessage});
        }
      }
    } else {
      // if (errors && errors.canDisplayMessageToUser) this.ui.toast(errors.message)
      // else this.ui.toast('An unexpected error has occured')
    }
  }

  public static isNotFutureDate(c: FormControl) {
    return (!moment(c.value).isAfter(moment(Date.now())))
    ? null : {
      isFutureDate: {
        valid: false
      }
    };
  }

  public resetServerValidation(form: FormGroup){
    for(let fieldName in form.controls){
      let control = form.controls[fieldName];
      control.setErrors(null);
    }
    form.setErrors(null);
  }
}